import React, { useEffect, useRef, useState } from 'react'

import { adminGetUserNameApi } from '../../../api/admin/user'
import { adminGetReportApi } from '../../../api/admin/survey'

import SavePDFButton from '../../../components/common/pdf/SavePDFButton'

import { useParams } from 'react-router-dom'
import ReportFormRead from '../../../components/survey/report/ReportFormRead'
import { swalErrorAlert } from '../../../utils/swal/swal'


const AdminSurveyReportRead = () => {
    const { userId } = useParams()

    /* 보고서 정보 */
    const [userName, setUserName] = useState('')
    const [reportInfo, setReportInfo] = useState(null)
    const [savedFiles, setSavedFiles] = useState([]) // 기존 파일
    const [updatedDate, setUpdatedDate] = useState('')

    useEffect(() => {
        getUserName(userId)
        getReportInfo(userId)

    }, [userId])



    const getUserName = async (userId) => {
        if (!userId) {
            setUserName('')
            return
        }

        try {
            const response = await adminGetUserNameApi(userId)

            if (response.data?.code === 200) {
                const userName = response.data?.resData?.user_name
                setUserName(userName)
            } else {
                setUserName('')
            }

        } catch (error) {
            swalErrorAlert()
            return
        }
    }

    const getReportInfo = async (userId) => {
        try {
            const response = await adminGetReportApi(userId)

            if (response.status === 200) {
                const jsonData = response.data?.resData?.json_data ? response.data?.resData?.json_data : null
                const savedFiles = response.data?.resData?.files ? response.data?.resData?.files : []
                const updatedData = response.data?.resData?.updated_date ? response.data?.resData?.updated_date : ''

                setReportInfo(jsonData)
                setSavedFiles(savedFiles)
                setUpdatedDate(updatedData)
                return
            }
            else if (response.status === 204) {
                setReportInfo(null)
                setSavedFiles([])
                setUpdatedDate('')
                return
            }

        } catch (error) {
            swalErrorAlert()
            return
        }
    }

    const pdfRef = useRef();

    return (
        <div className="container-fluid">
            {/* Heading */}
            <div className="mb-4">
                <h1 className="h3 mb-0">KGS 메가반 학생 분석 보고서</h1>
            </div>

            {/* Content */}
            <div className='card shadow'>
                <div className="card-header py-3">
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className="m-0 font-weight-bold">{userName} 학생 분석 보고서 작성</h6>
                        <div>
                            {updatedDate && <span className='text-primary me-3'>{updatedDate} 에 마지막으로 작성되었습니다.</span>}
                            <SavePDFButton pdfRef={pdfRef} fileName={`${userName} 학생 분석 보고서`} />
                        </div>
                    </div>
                </div>

                <ReportFormRead reportInfo={reportInfo} savedFiles={savedFiles} pdfRef={pdfRef} />

            </div>
        </div>
    )
}


export default AdminSurveyReportRead